const CreativeAgencyNewAbout = () => {
  return (
    <>
      <div className="sections">
        <div className="sections__head">
          <div className="container">
            <div className="row g-4 align-items-center justify-content-between">
              <div className="col-md-6">
                <h2 className="h3 about-title mb-0">
                  To contact us with ease if you need a specialist to create a
                  significant digital project, simply click
                </h2>
              </div>
              <div className="col-md-6 col-xl-5">
                <p className="mb-0">
                  Easily incorporate ready-to-use Webflow micro interactions
                  into your projects by simply copying and pasting them.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row g-4 justify-content-between">
            <div className="col-lg-6 col-xxl-5">
              <div className="about-36">
                <img
                  src="assets/img/about-img-1.png"
                  alt="About"
                  className="img-fluid"
                />
                <div className="about-36__box">
                  <h2 className="about-36__box-title mb-2 fw-semibold">25+</h2>
                  <p className="mb-0 about-36__box-subtitle">Year Experience</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <h2 className="mb-32 about-title">
                Best creative & modern digital agency.
              </h2>
              <p className="mb-0">
                Globally expedite sticky platforms whereas end-to-end vortals.
                Energistically synergize emerging. Monotonectally incubate
                bleeding-edge e-business.
              </p>
              <hr className="mt-40 mb-40" />
              <div className="d-flex align-items-center flex-wrap gap-12 mb-40">
                <div className="flex-shrink-0">
                  <h2 className="about-title">40k+</h2>
                  <p className="mb-0">
                    People and employees <br />
                    worldwide
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <h2 className="about-title">90+</h2>
                  <p className="mb-0">
                    Ethisphere’s World’s Most <br />
                    Ethical Companies
                  </p>
                </div>
              </div>
              <button type="button" className="btn btn-about-36">
                Get Started
              </button>
            </div>
            <div className="col-12 about-36-scroller">
              <div
                className="scroller-x mb-4"
                data-direction="left"
                data-speed="slow"
              >
                <ul className="list-unstyled p-0 m-0 d-flex gap-4 scroller-x__list">
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      SEO
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      BRANDING
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      WORDPRESS
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      DIGITAL MARKETING
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      CONTENT WRITING
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      WEB DEVELOPMENT
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      BRANDING
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      FULL STACK SOLUTION
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                  <li>
                    <span className="d-inline-block fw-semibold h6 about-title">
                      TEMPLATE
                    </span>
                  </li>
                  <li>
                    <img
                      src="assets/img/icon-star-sm.png"
                      alt="Icon"
                      className="img-fluid"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreativeAgencyNewAbout;
